import { useState } from 'react'
import { Alert, Box, Chip, Link, styled, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { IReportTemplateWarningDto } from 'src/generated-types/report-template'

export interface IVersionCompareSectionProps {
  warnings: IReportTemplateWarningDto
}

export const VersionCompareSection: React.FC<IVersionCompareSectionProps> = ({ warnings }) => {
  const { t: translate } = useTranslation(['dynamic-report'])
  const [showVersionCompare, setShowVersionCompare] = useState(false)

  if (warnings?.isLatestVersion && warnings.removedInLatest?.length === 0) return null

  return (
    <Box sx={{ mb: 1 }}>
      <Alert severity="info" sx={{ fontSize: '12px' }}>
        <Link
          component="button"
          underline="hover"
          onClick={() => setShowVersionCompare(prev => !prev)}
          sx={{ fontSize: '12px', cursor: 'pointer' }}
        >
          {translate('version-upgrade-warning-compare-link', { ns: 'dynamic-report' })}
        </Link>
      </Alert>
      {showVersionCompare && (
        <VersionCompareBox>
          {(warnings.removedInLatest?.length ?? 0) > 0 && (
            <Box>
              <Typography variant="caption" fontWeight={700} display="block" sx={{ mb: 0.5 }}>
                {translate('version-upgrade-warning-removed-section', { ns: 'dynamic-report' })}
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {warnings.removedInLatest.map((col, i) => (
                  <Chip
                    key={i}
                    label={col.name}
                    size="small"
                    color={col.isUsed ? 'error' : 'primary'}
                    variant="outlined"
                  />
                ))}
              </Box>
            </Box>
          )}
        </VersionCompareBox>
      )}
    </Box>
  )
}

const VersionCompareBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5),
}))
